module.exports = __webpack_public_path__ + "img/stanford-logo.795a7a4f.png";